module.exports = __webpack_public_path__ + "507a5fd3c3657b593b24aca49ee93cb4.pdf";